module.exports = __webpack_public_path__ + "141d4a85/img/scraper-icon.df6ccde5.svg";